module.exports = __webpack_public_path__ + "static/img/routeDetail-back.2675c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/routeDetail-back.png
// module id = Q9cl
// module chunks = 1